import React, { Component }  from 'react';
import {
    Space,
    Card,
    message,
    Button,
    Tag,
    PageHeader,
    Spin,
    Menu,
    Table,
    Typography,
    Input,
    DatePicker,
    Modal, Form
} from 'antd';
import '../../style.css';
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
import {EditOutlined, MailOutlined, UploadOutlined} from "@ant-design/icons";
import moment from "moment";
const { Column } = Table;
class BuildProject extends Component {
    constructor(props) {
        super(props);
        this.state={
            project:[],
            companyId:this.props.companyId,
            projectId:0,
            projectName:'',
            preview_visible:false,
            fileField:[],
            fileStream:'',
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
            loadingUpload:false,
            loadingPreview:false,
            projectCode:''
        }
    }
    componentDidMount(){
        //获取公司的所有项目名称
        fetchPost(global.constants.getBuildProjectSummaryGetG,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            project:res.data,
                        }))
                    }
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            upload_visible:false,
        }))
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(e){
        const value = e.projectId;
        const value1 =e.projectName;
        const value2 =e.code;
        this.setState(()=>({
            upload_visible:true,
            preview_visible:false,
            projectId: value,
            projectName: value1,
            projectCode: value2
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:value,
            productId:0,
            patentId:0,
            otherId:0,
            remark:value2 + value1 + '立项材料',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        this.setState(()=>({
                            checkStatus:true,
                        }))
                    }
                    else{
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                })
    }
    preview(){
        this.setState(()=>({
            loadingPreview:true
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:this.state.projectId,
            productId:0,
            patentId:0,
            otherId:0,
            remark:this.state.projectCode+this.state.projectName+'立项材料',
            url: '',
            fileName: ''
        }
        fetchPostFile(global.constants.previewFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=> {
                            let blobUrl = window.URL.createObjectURL(blob);
                            this.setState(()=>({
                                fileStream:blobUrl,
                                preview_visible:true,
                                loadingPreview:false
                            }))
                        })
                }
            )
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
            checkStatus:false,
        }))
    }
    uploadFile(){
        this.setState(()=>({
            loadingUpload:true,
        }))
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',this.state.projectId);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark',this.state.projectCode+this.state.projectName+'立项材料');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            this.setState(()=>({
                                loadingUpload:false,
                                checkStatus:true,
                                uploadFile_visible:false,
                            }))
                            //上传一个合并一次
                            let params1 = {
                                companyId:this.state.companyId,
                                remark:"立项材料"
                            }
                            fetchPost(global.constants.mergeReport, params1)
                                .then(
                                    res => {
                                        if (res.code === 200) {
                                            message.success("上传并合并成功").then()
                                        }
                                        else{
                                            message.info("未查询到可合并的文件！").then()
                                        }
                                    }
                                )
                        }
                    })
        }
    }
    delete(){
        let params = {
            companyId:this.state.companyId,
            projectId:this.state.projectId,
            productId:0,
            patentId:0,
            otherId:0,
            remark:this.state.projectCode+this.state.projectName+'立项材料',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                            preview_visible:false
                        }))
                    }
                }
            )
    }
    combine(){

    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="立项材料"
                        subTitle="立项材料包括立项决议、项目研究开发设计书、项目验收报告，只允许上传50M以内的pdf格式的文件"
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.project}>
                            {/*<Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>*/}
                            <Column align="center" title={<p className="list-column-style">项目编号</p>} dataIndex="code" key="code" />
                            <Column align="center" title={<p className="list-column-style">项目名称</p>} dataIndex="projectName" key="projectName" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<UploadOutlined />}
                                            onClick={this.handleUploadClick.bind(this,record)}
                                        >上传</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.upload_visible}
                    title={'上传附件'}
                    onCancel={this.hideModal.bind(this)}
                    width={'60%'}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                            完成
                        </Button>,
                    ]}
                >
                    <div>
                        该项目的立项材料
                        {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                        <Button type={"primary"} onClick={this.preview.bind(this)} disabled={!this.state.checkStatus}>预览</Button>
                        <Form style={{marginTop:'20px'}}>
                            <Form.Item
                                name='file'
                                method="post"
                                enctype="multipart/form-data"
                            >
                                <input
                                    type="file"
                                    name='file'
                                    onChange={this.fileInput.bind(this)}
                                />

                            </Form.Item>
                            <Form.Item name="preview_paper">
                                {
                                    this.state.loadingPreview === true &&
                                        <div style={{textAlign:'center'}}>
                                            <Spin tip={"加载预览中"}/>
                                        </div>
                                }
                                {
                                    this.state.preview_visible === true &&
                                    <div>
                                        <Button type={"primary"} onClick={this.delete.bind(this)}>删除</Button>
                                        <FileViewer fileType='pdf'
                                                    filePath={this.state.fileStream}
                                                    onError={this.onError}
                                        />
                                    </div>
                                }
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.uploadFile_visible}
                    title={'上传'}
                    onCancel={this.hideModalTwo.bind(this)}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                            确定
                        </Button>,
                    ]}
                >
                    {
                        this.state.loadingUpload === true ?
                            <div style={{textAlign:'center'}}>
                                <Spin tip={"上传中"}/>
                            </div>:
                            <div>确定上传该文件吗？</div>
                    }
                </Modal>
            </div>
        )
    }
}
export default BuildProject;